import { Box, Stack, styled, Switch } from '@mui/material';
import { colors } from '@watter/shared-components';

export const focuseEffect = () => ({
    content: "''",
    background:
        'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
    inset: 0,
    borderRadius: '28px',
    transform: 'scale(1.02, 1.06)',
});
export const CommonTable = styled(Box)(({ theme, height }) => ({
    '& .MuiPaper-root': {
        height,
        marginTop: theme.spacing(2),
        '&.cstInstaller': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
        '& .MuiDataGrid-root': {
            border: 'none',
            borderRadius: theme.spacing(1),
            '& .MuiDataGrid-row--borderBottom': {
                background: `${theme.palette.mode === 'dark' ? colors?.lightHead : colors?.lightGray} !important`,
                '& .MuiDataGrid-columnSeparator': {
                    display: 'none',
                },
                '& .MuiDataGrid-columnHeader': {
                    padding: theme.spacing(0, 2),
                    '&:focus': {
                        outline: 'none',
                    },
                },
            },
            '& .MuiDataGrid-row': {
                background: theme.palette.mode === 'dark' ? colors?.darkBgButton : colors?.whiteSmoke,
                cursor: 'pointer',
                '& .MuiDataGrid-cell': {
                    color: theme.palette.mode === 'dark' ? colors?.info : colors?.blackColor,
                    borderColor: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
                    padding: theme.spacing(0, 2),
                    cursor: 'pointer',
                    '&:focus,&:focus-visible': {
                        outline: 'none',
                    },
                    '& .MuiSvgIcon-root': {
                        color: theme.palette.mode === 'dark' ? colors.info : colors.blackColor,
                    },
                    '& .statusText': {
                        color: colors.white,
                        padding: theme.spacing(0.5),
                        borderRadius: theme.spacing(0.5),
                        width: theme.spacing(12.5),
                    },
                },
                '& .MuiDataGrid-cell:not(.cstRemovePointer)': {
                    pointerEvents: 'none',
                },
                '&.cstDisablePointer': {
                    pointerEvents: 'none',
                    cursor: 'not-allowed',
                },
                '&.Mui-selected': {
                    backgroundColor: 'transparent',
                },
            },
            '& .MuiDataGrid-filler': {
                '& div': {
                    border: 'none',
                },
            },
        },
        '& .MuiPagination-root': {
            '& .MuiPagination-ul': {
                justifyContent: 'flex-end',
                padding: theme.spacing(3, 0),
                '& .MuiPaginationItem-previousNext': {
                    border: '1px solid',
                },
            },
        },
    },
}));
export const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#65C466',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        background: colors?.white,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        boxSizing: 'border-box',
        backgroundColor: theme.palette.mode === 'dark' ? colors?.lightTrack : colors?.lightGray,
    },
}));
export const CustomSwitch = styled(Switch)(() => ({
    '& .MuiSwitch-thumb': {
        background: '#2FABE1',
    },
    '& .MuiSwitch-track': {
        background: `${colors.gray} !important`,
    },
}));
export const Details = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(3),
    background: theme.palette.mode === 'dark' ? colors?.darkBgButton : colors?.whiteSmoke,
    borderRadius: theme.spacing(1),
    '& .MuiGrid2-container': {
        rowGap: theme.spacing(3),
        '& .MuiGrid2-root': {
            gap: theme.spacing(1.5),
            display: 'flex',
            flexDirection: 'column',
            '& .MuiTypography-subtitle1': {
                color: theme.palette.mode === 'dark' ? colors?.info : colors?.gray,
            },
        },
    },
}));
